"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Array$from = require("@babel/runtime-corejs2/core-js/array/from");
var _Symbol = require("@babel/runtime-corejs2/core-js/symbol");
var _Symbol$iterator = require("@babel/runtime-corejs2/core-js/symbol/iterator");
var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _lodash = require("lodash");
var _webexErrors = require("../common/errors/webex-errors");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _constants = require("../constants");
var _browserDetection = _interopRequireDefault(require("../common/browser-detection"));
var _intentToJoin = _interopRequireDefault(require("../common/errors/intent-to-join"));
var _joinMeeting2 = _interopRequireDefault(require("../common/errors/join-meeting"));
var _parameter = _interopRequireDefault(require("../common/errors/parameter"));
var _permission = _interopRequireDefault(require("../common/errors/permission"));
var _passwordError = _interopRequireDefault(require("../common/errors/password-error"));
var _captchaError = _interopRequireDefault(require("../common/errors/captcha-error"));
var _triggerProxy = _interopRequireDefault(require("../common/events/trigger-proxy"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && o[_Symbol$iterator] || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var MeetingUtil = {
  parseLocusJoin: function parseLocusJoin(response) {
    var parsed = {};

    // First todo: add check for existance
    parsed.locus = response.body.locus;
    parsed.mediaConnections = response.body.mediaConnections;
    parsed.locusUrl = parsed.locus.url;
    parsed.locusId = parsed.locus.url.split('/').pop();
    parsed.selfId = parsed.locus.self.id;

    // we need mediaId before making roap calls
    parsed.mediaConnections.forEach(function (mediaConnection) {
      if (mediaConnection.mediaId) {
        parsed.mediaId = mediaConnection.mediaId;
      }
    });
    return parsed;
  },
  remoteUpdateAudioVideo: function remoteUpdateAudioVideo(meeting, audioMuted, videoMuted) {
    if (!meeting) {
      return _promise.default.reject(new _parameter.default('You need a meeting object.'));
    }
    if (!meeting.locusMediaRequest) {
      return _promise.default.reject(new _parameter.default('You need a meeting with a media connection, call Meeting.addMedia() first.'));
    }
    return meeting.locusMediaRequest.send({
      type: 'LocalMute',
      selfUrl: meeting.selfUrl,
      mediaId: meeting.mediaId,
      sequence: meeting.locusInfo.sequence,
      muteOptions: {
        audioMuted: audioMuted,
        videoMuted: videoMuted
      }
    }).then(function (response) {
      var _response$body;
      return response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.locus;
    });
  },
  hasOwner: function hasOwner(info) {
    return info && info.owner;
  },
  isOwnerSelf: function isOwnerSelf(owner, selfId) {
    return owner === selfId;
  },
  isPinOrGuest: function isPinOrGuest(err) {
    var _err$body;
    return (err === null || err === void 0 ? void 0 : (_err$body = err.body) === null || _err$body === void 0 ? void 0 : _err$body.errorCode) && _constants.INTENT_TO_JOIN.includes(err.body.errorCode);
  },
  /**
   * Returns the current state of knowledge about whether we are on an ipv4-only or ipv6-only or mixed (ipv4 and ipv6) network.
   * The return value matches the possible values of "ipver" parameter used by the backend APIs.
   *
   * @param {Object} webex webex instance
   * @returns {IP_VERSION|undefined} ipver value to be passed to the backend APIs or undefined if we should not pass any value to the backend
   */
  getIpVersion: function getIpVersion(webex) {
    var _webex$internal$devic = webex.internal.device.ipNetworkDetector,
      supportsIpV4 = _webex$internal$devic.supportsIpV4,
      supportsIpV6 = _webex$internal$devic.supportsIpV6;
    if (!webex.config.meetings.backendIpv6NativeSupport && (0, _browserDetection.default)().isBrowser('firefox')) {
      // when backend doesn't support native ipv6,
      // then our NAT64/DNS64 based solution relies on FQDN ICE candidates, but Firefox doesn't support them,
      // see https://bugzilla.mozilla.org/show_bug.cgi?id=1713128
      // so for Firefox we don't want the backend to activate the "ipv6 feature"
      return undefined;
    }
    if (supportsIpV4 && supportsIpV6) {
      return _constants.IP_VERSION.ipv4_and_ipv6;
    }
    if (supportsIpV4) {
      return _constants.IP_VERSION.only_ipv4;
    }
    if (supportsIpV6) {
      return _constants.IP_VERSION.only_ipv6;
    }
    return _constants.IP_VERSION.unknown;
  },
  joinMeeting: function () {
    var _joinMeeting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(meeting, options) {
      var _meeting$meetingInfo;
      var webex, reachability, clientMediaPreferences;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (meeting) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", _promise.default.reject(new _parameter.default('You need a meeting object.')));
          case 2:
            webex = meeting.getWebexObject(); // @ts-ignore
            webex.internal.newMetrics.submitClientEvent({
              name: 'client.locus.join.request',
              options: {
                meetingId: meeting.id
              }
            });
            clientMediaPreferences = {
              // bare minimum fallback value that should allow us to join
              ipver: _constants.IP_VERSION.unknown,
              joinCookie: undefined,
              preferTranscoding: !meeting.isMultistream
            };
            _context.prev = 5;
            _context.next = 8;
            return webex.meetings.reachability.getClientMediaPreferences(meeting.isMultistream, MeetingUtil.getIpVersion(webex));
          case 8:
            clientMediaPreferences = _context.sent;
            if (!options.roapMessage) {
              _context.next = 13;
              break;
            }
            _context.next = 12;
            return webex.meetings.reachability.getReachabilityReportToAttachToRoap();
          case 12:
            reachability = _context.sent;
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            _loggerProxy.default.logger.error('Meeting:util#joinMeeting --> Error getting reachability or clientMediaPreferences:', _context.t0);
          case 18:
            return _context.abrupt("return", meeting.meetingRequest.joinMeeting({
              inviteeAddress: meeting.meetingJoinUrl || meeting.sipUri,
              meetingNumber: meeting.meetingNumber,
              deviceUrl: meeting.deviceUrl,
              locusUrl: meeting.locusUrl,
              locusClusterUrl: (_meeting$meetingInfo = meeting.meetingInfo) === null || _meeting$meetingInfo === void 0 ? void 0 : _meeting$meetingInfo.locusClusterUrl,
              correlationId: meeting.correlationId,
              reachability: reachability,
              roapMessage: options.roapMessage,
              permissionToken: meeting.permissionToken,
              resourceId: options.resourceId || null,
              moderator: options.moderator,
              pin: options.pin,
              moveToResource: options.moveToResource,
              asResourceOccupant: options.asResourceOccupant,
              breakoutsSupported: options.breakoutsSupported,
              locale: options.locale,
              deviceCapabilities: options.deviceCapabilities,
              liveAnnotationSupported: options.liveAnnotationSupported,
              clientMediaPreferences: clientMediaPreferences
            }).then(function (res) {
              var parsed = MeetingUtil.parseLocusJoin(res);
              meeting.setLocus(parsed);
              webex.internal.newMetrics.submitClientEvent({
                name: 'client.locus.join.response',
                payload: {
                  trigger: 'loci-update',
                  identifiers: {
                    trackingId: res.headers.trackingid
                  }
                },
                options: {
                  meetingId: meeting.id,
                  mediaConnections: parsed.mediaConnections
                }
              });
              return parsed;
            }));
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 15]]);
    }));
    function joinMeeting(_x, _x2) {
      return _joinMeeting.apply(this, arguments);
    }
    return joinMeeting;
  }(),
  cleanUp: function cleanUp(meeting) {
    meeting.getWebexObject().internal.device.meetingEnded();
    meeting.stopPeriodicLogUpload();
    meeting.breakouts.cleanUp();
    meeting.simultaneousInterpretation.cleanUp();
    meeting.locusMediaRequest = undefined;

    // make sure we send last metrics before we close the peerconnection
    var stopStatsAnalyzer = meeting.statsAnalyzer ? meeting.statsAnalyzer.stopAnalyzer() : _promise.default.resolve();
    return stopStatsAnalyzer.then(function () {
      return meeting.closeRemoteStreams();
    }).then(function () {
      return meeting.closePeerConnections();
    }).then(function () {
      meeting.cleanupLocalStreams();
      meeting.unsetRemoteStreams();
      meeting.unsetPeerConnections();
      meeting.reconnectionManager.cleanUp();
    }).then(function () {
      return meeting.stopKeepAlive();
    }).then(function () {
      var _meeting$config;
      if ((_meeting$config = meeting.config) !== null && _meeting$config !== void 0 && _meeting$config.enableAutomaticLLM) {
        meeting.updateLLMConnection();
      }
    });
  },
  disconnectPhoneAudio: function disconnectPhoneAudio(meeting, phoneUrl) {
    if (meeting.meetingState === _constants.FULL_STATE.INACTIVE) {
      return _promise.default.reject(new _webexErrors.MeetingNotActiveError());
    }
    var options = {
      locusUrl: meeting.locusUrl,
      selfId: meeting.selfId,
      correlationId: meeting.correlationId,
      phoneUrl: phoneUrl
    };
    return meeting.meetingRequest.disconnectPhoneAudio(options).catch(function (err) {
      _loggerProxy.default.logger.error("Meeting:util#disconnectPhoneAudio --> An error occured while disconnecting phone audio in meeting ".concat(meeting.id, ", error: ").concat(err));
      return _promise.default.reject(err);
    });
  },
  /**
   * Returns options for leaving a meeting.
   * @param {any} meeting
   * @param {any} options
   * @returns {any} leave options
   */
  prepareLeaveMeetingOptions: function prepareLeaveMeetingOptions(meeting) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaultOptions = {
      locusUrl: meeting.locusUrl,
      selfId: meeting.selfId,
      correlationId: meeting.correlationId,
      resourceId: meeting.resourceId,
      deviceUrl: meeting.deviceUrl
    };
    return _objectSpread(_objectSpread({}, defaultOptions), options);
  },
  // by default will leave on meeting's resourceId
  // if you explicity want it not to leave on resource id, pass
  // {resourceId: null}
  // TODO: chris, you can modify this however you want
  leaveMeeting: function leaveMeeting(meeting) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (meeting.meetingState === _constants.FULL_STATE.INACTIVE) {
      // TODO: clean up if the meeting is already inactive
      return _promise.default.reject(new _webexErrors.MeetingNotActiveError());
    }
    if (MeetingUtil.isUserInLeftState(meeting.locusInfo)) {
      return _promise.default.reject(new _webexErrors.UserNotJoinedError());
    }
    var leaveOptions = MeetingUtil.prepareLeaveMeetingOptions(meeting, options);
    return meeting.meetingRequest.leaveMeeting(leaveOptions).then(function () {
      if (options.moveMeeting) {
        return _promise.default.resolve();
      }
      return MeetingUtil.cleanUp(meeting);
    }).catch(function (err) {
      // TODO: If the meeting state comes as LEFT or INACTIVE as response then
      // 1)  on leave clean up the meeting or simply do a sync on the meeting
      // 2) If the error says meeting is inactive then destroy the meeting object
      _loggerProxy.default.logger.error("Meeting:util#leaveMeeting --> An error occured while trying to leave meeting with an id of ".concat(meeting.id, ", error: ").concat(err));
      return _promise.default.reject(err);
    });
  },
  declineMeeting: function declineMeeting(meeting, reason) {
    return meeting.meetingRequest.declineMeeting({
      locusUrl: meeting.locusUrl,
      deviceUrl: meeting.deviceUrl,
      reason: reason
    });
  },
  isUserInLeftState: function isUserInLeftState(locusInfo) {
    var _locusInfo$parsedLocu, _locusInfo$parsedLocu2;
    return ((_locusInfo$parsedLocu = locusInfo.parsedLocus) === null || _locusInfo$parsedLocu === void 0 ? void 0 : (_locusInfo$parsedLocu2 = _locusInfo$parsedLocu.self) === null || _locusInfo$parsedLocu2 === void 0 ? void 0 : _locusInfo$parsedLocu2.state) === _constants._LEFT_;
  },
  isUserInIdleState: function isUserInIdleState(locusInfo) {
    var _locusInfo$parsedLocu3, _locusInfo$parsedLocu4;
    return ((_locusInfo$parsedLocu3 = locusInfo.parsedLocus) === null || _locusInfo$parsedLocu3 === void 0 ? void 0 : (_locusInfo$parsedLocu4 = _locusInfo$parsedLocu3.self) === null || _locusInfo$parsedLocu4 === void 0 ? void 0 : _locusInfo$parsedLocu4.state) === _constants._IDLE_;
  },
  isUserInJoinedState: function isUserInJoinedState(locusInfo) {
    var _locusInfo$parsedLocu5, _locusInfo$parsedLocu6;
    return ((_locusInfo$parsedLocu5 = locusInfo.parsedLocus) === null || _locusInfo$parsedLocu5 === void 0 ? void 0 : (_locusInfo$parsedLocu6 = _locusInfo$parsedLocu5.self) === null || _locusInfo$parsedLocu6 === void 0 ? void 0 : _locusInfo$parsedLocu6.state) === _constants._JOINED_;
  },
  isMediaEstablished: function isMediaEstablished(currentMediaStatus) {
    return currentMediaStatus && (currentMediaStatus.audio || currentMediaStatus.video || currentMediaStatus.share);
  },
  joinMeetingOptions: function joinMeetingOptions(meeting) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var webex = meeting.getWebexObject();
    meeting.resourceId = meeting.resourceId || options.resourceId;
    if (meeting.requiredCaptcha) {
      return _promise.default.reject(new _captchaError.default());
    }
    if (meeting.passwordStatus === _constants.PASSWORD_STATUS.REQUIRED) {
      return _promise.default.reject(new _passwordError.default());
    }
    if (options.pin) {
      // @ts-ignore
      webex.internal.newMetrics.submitClientEvent({
        name: 'client.pin.collected',
        options: {
          meetingId: meeting.id
        }
      });
    }

    // normal join meeting, scenario A, D
    return MeetingUtil.joinMeeting(meeting, options).catch(function (err) {
      // joining a claimed PMR that is not my own, scenario B
      if (MeetingUtil.isPinOrGuest(err)) {
        webex.internal.newMetrics.submitClientEvent({
          name: 'client.pin.prompt',
          options: {
            meetingId: meeting.id
          }
        });

        // request host pin or non host for unclaimed PMR, start of Scenario C
        // see https://sqbu-github.cisco.com/WebExSquared/locus/wiki/Locus-Lobby-and--IVR-Feature
        return _promise.default.reject(new _intentToJoin.default('Error Joining Meeting', err));
      }
      _loggerProxy.default.logger.error('Meeting:util#joinMeetingOptions --> Error joining the call, ', err);
      return _promise.default.reject(new _joinMeeting2.default(options, 'Error Joining Meeting', err));
    });
  },
  /**
   * Returns request options for leaving a meeting.
   * @param {any} meeting
   * @param {any} options
   * @returns {any} request options
   */
  buildLeaveFetchRequestOptions: function buildLeaveFetchRequestOptions(meeting) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var leaveOptions = MeetingUtil.prepareLeaveMeetingOptions(meeting, options);
    return meeting.meetingRequest.buildLeaveMeetingRequestOptions(leaveOptions);
  },
  getTrack: function getTrack(stream) {
    var audioTrack = null;
    var videoTrack = null;
    var audioTracks = null;
    var videoTracks = null;
    if (!stream) {
      return {
        audioTrack: null,
        videoTrack: null
      };
    }
    if (stream.getAudioTracks) {
      audioTracks = stream.getAudioTracks();
    }
    if (stream.getVideoTracks) {
      videoTracks = stream.getVideoTracks();
    }
    if (audioTracks && audioTracks.length > 0) {
      var _audioTracks = audioTracks;
      var _audioTracks2 = (0, _slicedToArray2.default)(_audioTracks, 1);
      audioTrack = _audioTracks2[0];
    }
    if (videoTracks && videoTracks.length > 0) {
      var _videoTracks = videoTracks;
      var _videoTracks2 = (0, _slicedToArray2.default)(_videoTracks, 1);
      videoTrack = _videoTracks2[0];
    }
    return {
      audioTrack: audioTrack,
      videoTrack: videoTrack
    };
  },
  getModeratorFromLocusInfo: function getModeratorFromLocusInfo(locusInfo) {
    return locusInfo && locusInfo.parsedLocus && locusInfo.parsedLocus.info && locusInfo.parsedLocus.info && locusInfo.parsedLocus.info.moderator;
  },
  getPolicyFromLocusInfo: function getPolicyFromLocusInfo(locusInfo) {
    return locusInfo && locusInfo.parsedLocus && locusInfo.parsedLocus.info && locusInfo.parsedLocus.info && locusInfo.parsedLocus.info.policy;
  },
  getUserDisplayHintsFromLocusInfo: function getUserDisplayHintsFromLocusInfo(locusInfo) {
    var _locusInfo$parsedLocu7, _locusInfo$parsedLocu8;
    return (locusInfo === null || locusInfo === void 0 ? void 0 : (_locusInfo$parsedLocu7 = locusInfo.parsedLocus) === null || _locusInfo$parsedLocu7 === void 0 ? void 0 : (_locusInfo$parsedLocu8 = _locusInfo$parsedLocu7.info) === null || _locusInfo$parsedLocu8 === void 0 ? void 0 : _locusInfo$parsedLocu8.userDisplayHints) || [];
  },
  canInviteNewParticipants: function canInviteNewParticipants(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.ADD_GUEST);
  },
  canAdmitParticipant: function canAdmitParticipant(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.ROSTER_WAITING_TO_JOIN);
  },
  canUserLock: function canUserLock(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.LOCK_CONTROL_LOCK) && displayHints.includes(_constants.DISPLAY_HINTS.LOCK_STATUS_UNLOCKED);
  },
  canUserUnlock: function canUserUnlock(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.LOCK_CONTROL_UNLOCK) && displayHints.includes(_constants.DISPLAY_HINTS.LOCK_STATUS_LOCKED);
  },
  canUserRaiseHand: function canUserRaiseHand(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.RAISE_HAND);
  },
  canUserLowerAllHands: function canUserLowerAllHands(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.LOWER_ALL_HANDS);
  },
  canUserLowerSomeoneElsesHand: function canUserLowerSomeoneElsesHand(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.LOWER_SOMEONE_ELSES_HAND);
  },
  bothLeaveAndEndMeetingAvailable: function bothLeaveAndEndMeetingAvailable(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.LEAVE_TRANSFER_HOST_END_MEETING) || displayHints.includes(_constants.DISPLAY_HINTS.LEAVE_END_MEETING);
  },
  canManageBreakout: function canManageBreakout(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.BREAKOUT_MANAGEMENT);
  },
  canStartBreakout: function canStartBreakout(displayHints) {
    return !displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_BREAKOUT_START);
  },
  canBroadcastMessageToBreakout: function canBroadcastMessageToBreakout(displayHints) {
    var policies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return displayHints.includes(_constants.DISPLAY_HINTS.BROADCAST_MESSAGE_TO_BREAKOUT) && !!policies[_constants.SELF_POLICY.SUPPORT_BROADCAST_MESSAGE];
  },
  isSuppressBreakoutSupport: function isSuppressBreakoutSupport(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.UCF_SUPPRESS_BREAKOUTS_SUPPORT);
  },
  canAdmitLobbyToBreakout: function canAdmitLobbyToBreakout(displayHints) {
    return !displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_LOBBY_TO_BREAKOUT);
  },
  isBreakoutPreassignmentsEnabled: function isBreakoutPreassignmentsEnabled(displayHints) {
    return !displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_BREAKOUT_PREASSIGNMENTS);
  },
  canUserAskForHelp: function canUserAskForHelp(displayHints) {
    return !displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_ASK_FOR_HELP);
  },
  lockMeeting: function lockMeeting(actions, request, locusUrl) {
    if (actions && actions.canLock) {
      return request.lockMeeting({
        locusUrl: locusUrl,
        lock: true
      });
    }
    return _promise.default.reject(new _permission.default('Lock not allowed, due to joined property.'));
  },
  unlockMeeting: function unlockMeeting(actions, request, locusUrl) {
    if (actions && actions.canUnlock) {
      return request.lockMeeting({
        locusUrl: locusUrl,
        lock: false
      });
    }
    return _promise.default.reject(new _permission.default('Unlock not allowed, due to joined property.'));
  },
  handleAudioLogging: function handleAudioLogging(audioStream) {
    var LOG_HEADER = 'MeetingUtil#handleAudioLogging -->';
    if (audioStream) {
      var settings = audioStream.getSettings();
      var deviceId = settings.deviceId;
      _loggerProxy.default.logger.log(LOG_HEADER, "deviceId = ".concat(deviceId));
      _loggerProxy.default.logger.log(LOG_HEADER, 'settings =', (0, _stringify.default)(settings));
    }
  },
  handleVideoLogging: function handleVideoLogging(videoStream) {
    var LOG_HEADER = 'MeetingUtil#handleVideoLogging -->';
    if (videoStream) {
      var settings = videoStream.getSettings();
      var deviceId = settings.deviceId;
      _loggerProxy.default.logger.log(LOG_HEADER, "deviceId = ".concat(deviceId));
      _loggerProxy.default.logger.log(LOG_HEADER, 'settings =', (0, _stringify.default)(settings));
    }
  },
  endMeetingForAll: function endMeetingForAll(meeting) {
    if (meeting.meetingState === _constants.FULL_STATE.INACTIVE) {
      return _promise.default.reject(new _webexErrors.MeetingNotActiveError());
    }
    var endOptions = {
      locusUrl: meeting.locusUrl
    };
    return meeting.meetingRequest.endMeetingForAll(endOptions).then(function () {
      return MeetingUtil.cleanUp(meeting);
    }).catch(function (err) {
      _loggerProxy.default.logger.error("Meeting:util#endMeetingForAll An error occured while trying to end meeting for all with an id of ".concat(meeting.id, ", error: ").concat(err));
      return _promise.default.reject(err);
    });
  },
  canEnableClosedCaption: function canEnableClosedCaption(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.CAPTION_START);
  },
  isSaveTranscriptsEnabled: function isSaveTranscriptsEnabled(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.SAVE_TRANSCRIPTS_ENABLED);
  },
  canStartTranscribing: function canStartTranscribing(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.TRANSCRIPTION_CONTROL_START);
  },
  canStopTranscribing: function canStopTranscribing(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.TRANSCRIPTION_CONTROL_STOP);
  },
  isClosedCaptionActive: function isClosedCaptionActive(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.CAPTION_STATUS_ACTIVE);
  },
  canStartManualCaption: function canStartManualCaption(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.MANUAL_CAPTION_START);
  },
  canStopManualCaption: function canStopManualCaption(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.MANUAL_CAPTION_STOP);
  },
  isManualCaptionActive: function isManualCaptionActive(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.MANUAL_CAPTION_STATUS_ACTIVE);
  },
  isWebexAssistantActive: function isWebexAssistantActive(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.WEBEX_ASSISTANT_STATUS_ACTIVE);
  },
  canViewCaptionPanel: function canViewCaptionPanel(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.ENABLE_CAPTION_PANEL);
  },
  isRealTimeTranslationEnabled: function isRealTimeTranslationEnabled(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.DISPLAY_REAL_TIME_TRANSLATION);
  },
  canSelectSpokenLanguages: function canSelectSpokenLanguages(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.DISPLAY_NON_ENGLISH_ASR);
  },
  waitingForOthersToJoin: function waitingForOthersToJoin(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.WAITING_FOR_OTHERS);
  },
  canSendReactions: function canSendReactions(originalValue, displayHints) {
    if (displayHints.includes(_constants.DISPLAY_HINTS.REACTIONS_ACTIVE)) {
      return true;
    }
    if (displayHints.includes(_constants.DISPLAY_HINTS.REACTIONS_INACTIVE)) {
      return false;
    }
    return originalValue;
  },
  canUserRenameSelfAndObserved: function canUserRenameSelfAndObserved(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.CAN_RENAME_SELF_AND_OBSERVED);
  },
  canUserRenameOthers: function canUserRenameOthers(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.CAN_RENAME_OTHERS);
  },
  canShareWhiteBoard: function canShareWhiteBoard(displayHints) {
    return displayHints.includes(_constants.DISPLAY_HINTS.SHARE_WHITEBOARD);
  },
  /**
   * Adds the current locus sequence information to a request body
   * @param {Object} meeting The meeting object
   * @param {Object} requestBody The body of a request to locus
   * @returns {void}
   */
  addSequence: function addSequence(meeting, requestBody) {
    var _meeting$locusInfo;
    var sequence = meeting === null || meeting === void 0 ? void 0 : (_meeting$locusInfo = meeting.locusInfo) === null || _meeting$locusInfo === void 0 ? void 0 : _meeting$locusInfo.sequence;
    if (!sequence) {
      return;
    }
    requestBody.sequence = sequence;
  },
  /**
   * Updates the locus info for the meeting with the delta locus
   * returned from requests that include the sequence information
   * Returns the original response object
   * @param {Object} meeting The meeting object
   * @param {Object} response The response of the http request
   * @returns {Object}
   */
  updateLocusWithDelta: function updateLocusWithDelta(meeting, response) {
    var _response$body2;
    if (!meeting) {
      return response;
    }
    var locus = response === null || response === void 0 ? void 0 : (_response$body2 = response.body) === null || _response$body2 === void 0 ? void 0 : _response$body2.locus;
    if (locus) {
      meeting.locusInfo.handleLocusDelta(locus, meeting);
    }
    return response;
  },
  generateBuildLocusDeltaRequestOptions: function generateBuildLocusDeltaRequestOptions(originalMeeting) {
    var meetingRef = new WeakRef(originalMeeting);
    var buildLocusDeltaRequestOptions = function buildLocusDeltaRequestOptions(originalOptions) {
      var meeting = meetingRef.deref();
      if (!meeting) {
        return originalOptions;
      }
      var options = (0, _lodash.cloneDeep)(originalOptions);
      if (!options.body) {
        options.body = {};
      }
      MeetingUtil.addSequence(meeting, options.body);
      return options;
    };
    return buildLocusDeltaRequestOptions;
  },
  generateLocusDeltaRequest: function generateLocusDeltaRequest(originalMeeting) {
    var meetingRef = new WeakRef(originalMeeting);
    var buildLocusDeltaRequestOptions = MeetingUtil.generateBuildLocusDeltaRequestOptions(originalMeeting);
    var locusDeltaRequest = function locusDeltaRequest(originalOptions) {
      var meeting = meetingRef.deref();
      if (!meeting) {
        return _promise.default.resolve();
      }
      var options = buildLocusDeltaRequestOptions(originalOptions);
      return meeting.request(options).then(function (response) {
        return MeetingUtil.updateLocusWithDelta(meeting, response);
      });
    };
    return locusDeltaRequest;
  },
  selfSupportsFeature: function selfSupportsFeature(feature, userPolicies) {
    if (!userPolicies) {
      return true;
    }
    return userPolicies[feature];
  },
  parseInterpretationInfo: function parseInterpretationInfo(meeting, meetingInfo) {
    var _meetingInfo$meetingS;
    if (!meeting || !meetingInfo) {
      return;
    }
    var siInfo = meetingInfo.simultaneousInterpretation;
    meeting.simultaneousInterpretation.updateMeetingSIEnabled(!!meetingInfo.turnOnSimultaneousInterpretation, !!(siInfo !== null && siInfo !== void 0 && siInfo.currentSIInterpreter));
    var hostSIEnabled = !!(meetingInfo.turnOnSimultaneousInterpretation && meetingInfo !== null && meetingInfo !== void 0 && (_meetingInfo$meetingS = meetingInfo.meetingSiteSetting) !== null && _meetingInfo$meetingS !== void 0 && _meetingInfo$meetingS.enableHostInterpreterControlSI);
    meeting.simultaneousInterpretation.updateHostSIEnabled(hostSIEnabled);
    function renameKey(obj, oldKey, newKey) {
      if (oldKey in obj) {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
      }
    }
    if (siInfo) {
      var _meeting$simultaneous, _meeting$simultaneous2;
      var lanuagesInfo = (0, _lodash.cloneDeep)(siInfo.siLanguages);
      var _iterator = _createForOfIteratorHelper(lanuagesInfo),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var language = _step.value;
          renameKey(language, 'languageCode', 'languageName');
          renameKey(language, 'languageGroupId', 'languageCode');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!((_meeting$simultaneous = meeting.simultaneousInterpretation) !== null && _meeting$simultaneous !== void 0 && (_meeting$simultaneous2 = _meeting$simultaneous.siLanguages) !== null && _meeting$simultaneous2 !== void 0 && _meeting$simultaneous2.length)) {
        meeting.simultaneousInterpretation.updateInterpretation({
          siLanguages: lanuagesInfo
        });
      }
    }
    _triggerProxy.default.trigger(meeting, {
      file: 'meeting/util',
      function: 'parseInterpretationInfo'
    }, _constants.EVENT_TRIGGERS.MEETING_INTERPRETATION_UPDATE);
  },
  /**
   * Returns a CA-recognized error payload for the specified raw error message/reason.
   *
   * New errors can be added to this function for handling in the future
   *
   * @param {String} reason the raw error message
   * @returns {Array<object>} an array of payload objects
   */
  getChangeMeetingFloorErrorPayload: function getChangeMeetingFloorErrorPayload(reason) {
    var errorPayload = {
      errorDescription: reason,
      name: 'locus.response',
      shownToUser: false
    };
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.UNDEFINED)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'signaling',
        errorCode: 1100
      })];
    }
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.DEVICE_NOT_JOINED)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'signaling',
        errorCode: 4050
      })];
    }
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.NO_MEDIA_FOR_DEVICE)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'media',
        errorCode: 2048
      })];
    }
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.NO_CONFLUENCE_ID)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'signaling',
        errorCode: 4064
      })];
    }
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.CONTENT_SHARING_DISABLED)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'expected',
        errorCode: 4065
      })];
    }
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.LOCUS_PARTICIPANT_DNE)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'signaling',
        errorCode: 4066
      })];
    }
    if (reason.includes(_constants.LOCAL_SHARE_ERRORS.CONTENT_REQUEST_WHILE_PENDING_WHITEBOARD)) {
      return [_objectSpread(_objectSpread({}, errorPayload), {}, {
        fatal: true,
        category: 'expected',
        errorCode: 4067
      })];
    }

    // return unknown error
    return [_objectSpread(_objectSpread({}, errorPayload), {}, {
      fatal: true,
      category: 'signaling',
      errorCode: 1100
    })];
  }
};
var _default = exports.default = MeetingUtil;
//# sourceMappingURL=util.js.map
